angular.module('agreements')
    .component('agreementShow', {
        bindings: {
            item: '<'
        },
        templateUrl: 'app/agreements/show.html',
        controller: function ($scope, $rootScope, $state, $window, Agreement, AgreementService, Principal, AgreementConst, InvoiceService) {
            this.AgreementService = AgreementService;

            this.$onInit = () => {
                Principal.currentUser().then(user => {
                    this.isWorker = this.item.worker != null && this.item.worker.id === user.id
                })
                Agreement.children({id: this.item.id}).$promise.then(result => this.children = result)
                Agreement.touches({id: this.item.id}).$promise.then(items => this.touches = items)
                this.canReadContractBgt = ['AGREEMENT', 'ORDER', 'OFFER'].includes(this.item.type) && Principal.hasAnyAuthority(['ROLE_CONTRACT_BGT_READ', 'ROLE_ADMIN'])
                this.canSeeDF = ['AGREEMENT', 'ORDER'].includes(this.item.type) && Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_MODULE'])
                InvoiceService.workflow.load().then(configuration => {
                    this.canSeeSubcontractorStatements =
                        configuration.subcontractorStatements.enabled
                        && this.item.type === 'AGREEMENT'
                        && this.item.subcontractorStatementsEnabled
                        && Principal.hasAnyAuthority([
                            'ROLE_INVOICE_DOCUMENTS_SUBCONTRACTOR_STATEMENTS_READ',
                            'ROLE_INVOICE_DOCUMENTS_SUBCONTRACTOR_STATEMENTS_WRITE_WITH_READ_ACCESS',
                            'ROLE_ADMIN'
                        ])
                })
                this.isOrder = this.item.type === 'ORDER'
                this.isAgreement = ['AGREEMENT', 'ANNEX'].includes(this.item.type)
                this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD']) && (this.isOrder || this.isAgreement)
                this.businessThreadResourceType = this.isOrder ? 'AGREEMENT_ORDER' : 'AGREEMENT'
                this.types = AgreementService.getTypes(this.item.type)
            }

            this.cancel = () => $window.history.back();

            $scope.$on(AgreementConst.eventUpdate, () => {
                $rootScope.$broadcast('document.comments.reload', this.item.id)
                $state.reload();
            })
            $scope.$on('agreement.deleted', () => this.cancel())
            $scope.$on("file.saved", () => $state.reload())
        }
    })
